import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://pmsapi.valleyhatcheryllc.com/",
  // baseURL: "http://127.0.0.1:8000/",
});

export default axiosInstance;
